import React, { useState, useRef } from 'react';
import {
	Card,
	Col,
	FieldWrapper,
	Form,
	Input,
	PrimaryButton,
	ScreenReaderText,
	Svg,
} from '@mlc/web-ui-toolkit';
import { filter } from '@mlc/symbols';
import styled from 'styled-components';
import { showLiveInfo } from '../../../../../events/NotificationEmitter';
import planProfileTestIds from '../PlanProfile.elements';

export interface QuickFilterProps {
	fetchData: Function;
	placeholder?: string;
}

const QuickFilter: React.FunctionComponent<QuickFilterProps> = ({
	fetchData,
	placeholder,
}: QuickFilterProps) => {
	const [value, setValue] = useState('');
	const searchBoxRef = useRef<any>();

	const focusBackOnSearchBox = () => {
		if (searchBoxRef.current) {
			searchBoxRef.current.focus();
		}
	};
	const onClick = async () => {
		await fetchData(value);
		showLiveInfo('Table below has been filtered by '.concat(value));
		focusBackOnSearchBox();
	};

	return (
		<Form
			onSubmit={(e: any) => {
				e.preventDefault();
			}}
		>
			<FieldWrapper label="Quick Filtering:" id="quick-filter">
				<Card justifyContent="flex-start" display="flex" alignItems="stretch">
					<SearchInput
						ref={searchBoxRef}
						value={value}
						onChange={(event: any) => {
							setValue(event.target.value);
						}}
						id="field-quick-filter"
						placeholder={placeholder}
						data-analytics-capture-value
					/>
					<SearchButton
						onClick={onClick}
						aria-label="Filter"
						data-id={planProfileTestIds.quickFilter}
					>
						<SearchSvg marginRight={1} symbol={filter} />
					</SearchButton>
				</Card>
			</FieldWrapper>
		</Form>
	);
};

const SearchButton = styled(PrimaryButton)`
	padding: 0;
	width: 44px;
`;

const SearchSvg = styled(Svg)`
	margin-right: 0px;
`;

const SearchInput = styled(Input)`
	height: 44px;
`;

export default QuickFilter;
